import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Container,
    Card,
    CardMedia,
    CircularProgress,
    List,
    ListItem,
    Grid,
} from "@mui/material";

function Manufacturing() {
    const [manufacturing, setManufacturing] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios({
            method: "GET",
            url: "/files/industries/manufacturing.txt",
        })
            .then((res) => {
                setManufacturing(res.data);
                setLoading(false);
            })
            .catch((err) => console.error("Error fetching data:", err));
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            {/* Title */}
            <Typography
                variant="h3"
                align="center"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: "#030366",
                    mt: 7,
                    fontSize: {
                        xs: "1.8rem",  // mobile (~h4)
                        sm: "2.2rem",  // tablet (~h3)
                        md: "2.8rem",  // laptop (~h3+)
                        lg: "3rem",    // desktop (~h2)
                    },
                }}
            >
                Manufacturing
            </Typography>

            {loading ? (
                <Box display="flex" justifyContent="center" mt={4}>
                    <CircularProgress color="secondary" />
                </Box>
            ) : (
                <Grid
                    container
                    spacing={4}
                    alignItems="flex-start"
                    sx={{
                        flexDirection: {
                            xs: "column", // mobile
                            sm: "column", // tablet
                            md: "row",   // laptop & desktop
                        },
                    }}
                >
                    {/* Content Section */}
                    <Grid
                        item
                        xs={12}
                        md={7}
                        sx={{
                            width: { xs: "100%", md: "100%" },
                            order: { xs: 1, md: 1 }, // content first always
                        }}
                    >
                        {manufacturing &&
                            manufacturing.map((data, index) => (
                                <Box key={index} mb={3}>
                                    {Array.isArray(data) ? (
                                        <List sx={{ pl: 3 }}>
                                            {data.map((subItem, subIndex) => (
                                                <ListItem
                                                    key={subIndex}
                                                    sx={{
                                                        display: "list-item",
                                                        listStyleType: "disc",
                                                        pl: 1,
                                                        fontSize: "16px",
                                                    }}
                                                >
                                                    {subItem}
                                                </ListItem>
                                            ))}
                                        </List>
                                    ) : (
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                mb: 2,
                                                textAlign: "justify",
                                                fontSize: "18px",
                                            }}
                                        >
                                            {data}
                                        </Typography>
                                    )}
                                </Box>
                            ))}
                    </Grid>
                </Grid>
            )}
        </Container>
    );
}

export default Manufacturing;










// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//     Box,
//     Typography,
//     Container,
//     Card,
//     CardContent,
//     CircularProgress,
//     List,
//     ListItem,
// } from "@mui/material";

// function Manufacturing() {
//     const [manufacturing, setManufacturing] = useState(null);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         axios({
//             method: "GET",
//             url: "/files/industries/manufacturing.txt",
//         }).then((res) => {
//             setManufacturing(res.data);
//             setLoading(false);
//         });
//     }, []);

//     return (
//         <Container maxWidth="md" sx={{ py: 2 }}>
//             {/* Title */}
//             <Typography
//                 variant="h3"
//                 align="center"
//                 gutterBottom
//                 sx={{ fontWeight: "bold", color: "#030366", mt: 7 }}
//             >
//                 Manufacturing
//             </Typography>

//             {loading ? (
//                 <Box display="flex" justifyContent="center" mt={4}>
//                     <CircularProgress color="secondary" />
//                 </Box>
//             ) : (
//                 <>
//                     {manufacturing &&
//                         manufacturing.map((data, index) => (
//                             <Box key={index} mb={3}>
//                                 {Array.isArray(data) ? (
//                                     <List sx={{ pl: 3 }}>
//                                         {data.map((subItem, subIndex) => (
//                                             <ListItem
//                                                 key={subIndex}
//                                                 sx={{
//                                                     display: "list-item",
//                                                     listStyleType: "disc",
//                                                     pl: 1,
//                                                     fontSize: "16px",
//                                                 }}
//                                             >
//                                                 {subItem}
//                                             </ListItem>
//                                         ))}
//                                     </List>
//                                 ) : (
//                                     <Typography
//                                         variant="body1"
//                                         sx={{ mb: 2, textAlign: "justify", fontSize: "18px" }}
//                                     >
//                                         {data}
//                                     </Typography>
//                                 )}
//                             </Box>
//                         ))}
//                 </>
//             )}
//         </Container>
//     );
// }

// export default Manufacturing;
